<template lang="pug">
    div.End
        lessonHeader
        stepTitle
        div.End-title Descrubre más oportunidades...
        v-layout.mt-3(row wrap)
            v-flex(xs12, md4).End-left
                    
                    span.link3 ¡Ya tienes un plan de vida! ¿Te gustaría conocer más a profundidad alguno de los productos financieros que lo componen?
                    v-spacer.py-2
                    div 
                        <a class="link" target='_blank' href="https://www.bbva.mx/educacion-financiera/plan-de-ahorro.html">Plan de ahorro</a>
                    div 
                        <a class="link" target='_blank' href="https://www.bbva.mx/educacion-financiera/mejor-credito-hipotecario.html">Para un mejor crédito hipotecario</a>   
                    div 
                        <a class="link" target='_blank' href="https://www.bbva.mx/educacion-financiera/como-invertir-mi-dinero.html">¿Cómo invertir mi dinero?</a>
            v-flex(xs12, md8)
                v-layout.pt-4(row wrap)
                    v-flex(xs12, md3)
                        img.ml-sm-5(src="@/assets/TPV-L1-7-Pagina7 A-1.png" alt="avatar" style="width: 140px; height: auto;")
                    v-flex(xs12, md9)
                        div.End-text(style="display: inline-block;") ¿Quieres aprender más sobre algún tema financiero? Complementa tu aprendizaje en<a target='_blank' href="https://www.bbvaeducacionfinanciera.mx/"> Blog de Educacion Financiera.</a>
                v-layout.mt-5(row wrap)
                    v-flex(xs12, md3)
                        img.ml-sm-5(src="@/assets/TPV-L1-7-Pagina7 A.png" alt="avatar" style="width: 140px; height: auto;")
                    v-flex(xs12, md9)
                        div.End-text(style="display: inline-block;") ¡Revisa todos los <a target='_blank' href="https://www.bbva.mx/personas/apps.html">otros productos</a> que Bancomer tiene para ti!                
        el-button.End-button.mt-5(type="primary" @click="toEnd") Finalizar
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
import lessonHeader from "@/components/lesson-header/lesson-header";
import stepTitle from '@/components/step-title/step-title'
import imageLoader from '@/components/image-loader/image-loader'
import buttonNext from '@/components/button-next/button-next'

export default {
  name: 'End',
  components:{
	lessonHeader,    
    stepTitle,
    imageLoader,
    buttonNext
  }, 
  computed: {
    ...mapGetters(['currentStep'])
  },
  methods: {
    ...mapActions(['finishSCORM']),
    toEnd() {
        this.finishSCORM();
        window.location.href = 'https://www.bbva.mx/educacion-financiera/talleres-en-linea.html'
    }
  }
}
</script>

<style scoped>
    @import 'end.scss';
</style>

